import React, { useMemo, useState, useEffect } from 'react';
import CustomIcon from '../../UI/CustomIcon';
import UserToggleSettings from '../user-toggle-settings';
import NotificationsSidebar from '../../notifications-sidebar';
import { useNotificationsContext } from '../../../notifications/NotificationsProvider';
import { useUser } from '../../../contexts/UserContext';
import Avatar from '../../../assets/icons/all/avatar.png';
import fileService from '../../../services/fileService';
import './UserSection.scss';

const UserSection = () => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState(null);
  const { unreadCount } = useNotificationsContext();
  const { user } = useUser();

  const displayName = useMemo(() => {
    const firstName = user?.firstName || '';
    const lastName = user?.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    if (fullName) return fullName;
    return user?.name || user?.email || 'User';
  }, [user]);

  const displayEmail = useMemo(() => {
    return user?.email || 'user@example.com';
  }, [user]);

  // Load avatar URL when user changes
  useEffect(() => {
    const loadAvatar = async () => {
      if (user?.profileImage) {
        // If it's already a full URL (signed URL or blob), use it directly
        if (user.profileImage.startsWith('http://') || user.profileImage.startsWith('https://') || user.profileImage.startsWith('blob:')) {
          setAvatarUrl(user.profileImage);
        } else {
          // Get signed URL for S3 key
          try {
            const signedUrl = await fileService.getSignedUrl(user.profileImage, 3600);
            setAvatarUrl(signedUrl || user.profileImage);
          } catch (error) {
            console.error('Error loading avatar:', error);
            setAvatarUrl(null);
          }
        }
      } else {
        setAvatarUrl(null);
      }
    };
    loadAvatar();
  }, [user?.profileImage]);

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
  };

  return (
    <div className="user-section">
      {/* Notification Button */}
      <button 
        className="notification-btn"
        onClick={toggleNotifications}
        aria-label="Open notifications"
      >
        <CustomIcon name="notifa" size={32} gradient="primary" />
        {unreadCount > 0 && (
          <span className="notification-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {/* User Info with Toggle */}
      <div className="user-info-toggle" onClick={toggleSettings}>
        <div className="user-avatar">
          {avatarUrl ? (
            <img 
              src={avatarUrl} 
              alt="User Avatar" 
              className="avatar-image"
            />
          ) : (
            <img 
              src={Avatar} 
              alt="User Avatar" 
              className="avatar-image"
            />
          )}
        </div>
        <div className="user-details">
          <div className="user-name">{displayName}</div>
          <div className="user-email">{displayEmail}</div>
        </div>
        <CustomIcon name="down1" size={24} color={"white"} className="toggle-icon" />
      </div>

      {/* User Toggle Settings */}
      <UserToggleSettings 
        isOpen={isSettingsOpen} 
        onClose={() => setIsSettingsOpen(false)} 
      />

      {/* Notifications Sidebar */}
      <NotificationsSidebar
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
      />

    </div>
  );
};

export default UserSection;